import React from "react";
import { Button, Typography, Space, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { UserAddOutlined } from "@ant-design/icons";
import { usePatientController } from "../../../../hooks/revi/usePatientController";
import { PatientList } from "../../../../components/Admin/InstitutionCmp/PatientCmp";
import { PatientFormModal } from "../../../../components/Admin/InstitutionCmp/PatientCmp";
import "./Page_Institution_Patients.scss";

const { Title, Text } = Typography;

export function Page_Institution_Patients() {
  // El namespace se declara aqui y no en cada cadena: i18next carga solo el
  // fichero que necesita esta pantalla.
  const { t } = useTranslation("institution");

  const {
    patients,
    therapistsList,
    pagination,
    loading,
    showModal,
    editingPatient,
    institutionId,
    loadData,
    openNewModal,
    openEditModal,
    closeModal,
    handleDelete,
  } = usePatientController();

  return (
    <div className="page-institution-patients">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 32,
        }}
      >
        <Space orientation="vertical" size={2}>
          <Title level={2} style={{ margin: 0 }}>
            {t("patients.listTitle")}
          </Title>
          <Text type="secondary">{t("patients.listSubtitle")}</Text>
        </Space>
        <Button
          type="primary"
          icon={<UserAddOutlined />}
          size="large"
          onClick={openNewModal}
        >
          {t("patients.new")}
        </Button>
      </div>

      {loading && patients.length === 0 ? (
        <div style={{ padding: 50, textAlign: "center" }}>
          <Spin size="large" />
        </div>
      ) : (
        <PatientList
          patients={patients}
          pagination={pagination}
          loading={loading}
          onPageChange={(page) => loadData(page)}
          onEdit={openEditModal}
          onDelete={handleDelete}
        />
      )}

      <PatientFormModal
        visible={showModal}
        onClose={closeModal}
        patient={editingPatient}
        institutionId={institutionId}
        therapistsList={therapistsList} // Pasamos la lista para el Select
        onSuccess={() => loadData(pagination.page)}
      />
    </div>
  );
}
